import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ordinalDate',
    standalone: false
})
export class OrdinalDatePipe implements PipeTransform {

  transform(value: string, type: string = null!): string {
    if (!value) { return ''; }

    const date = new Date(value);
    const months = ["January", "February", "March", "April", "May", "June", "July",
      "August", "September", "October", "November", "December"];
      
    switch(type) {
      case 'monthly': return `${date.getDate()}<sup>${this.nth(date.getDate())}</sup>`;
      case 'annually': return `${months[date.getMonth()]} ${date.getDate()}<sup>${this.nth(date.getDate())}</sup>`;
      default: return `${date.getDate()}${this.nth(date.getDate())} ${months[date.getMonth()]} ${date.getFullYear()}`;
    }
  }

  nth(d: any) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  }
}
